import { InfluencerProfileSponsoredPosts, InfluencerProfileSponsoredPostsProps } from '../shared';

type InfluencerTwitterProfileSponsoredPostsProps = InfluencerProfileSponsoredPostsProps;

export const InfluencerTwitterProfileSponsoredPosts = (props: InfluencerTwitterProfileSponsoredPostsProps) => (
  <InfluencerProfileSponsoredPosts {...props} />
);
